
window.aboundShowBoardMember = (clickEvent) => {
    const hideOverlay = (overlayEl) => {
        document.body.classList.remove('noscroll')
        overlayEl.remove()
    }

    const showOverlay = (fullMemberEl) => {
        const overlay = document.createElement('div')
        overlay.classList.add('overlay')
        overlay.addEventListener('click', ({currentTarget}) => {
            hideFullMember(fullMemberEl)
            hideOverlay(currentTarget)
        })
        document.body.classList.add('noscroll')
        document.body.appendChild(overlay)
        return overlay
    }

    const showFullMember = (fullMemberEl) => fullMemberEl.style.display = 'block'
    const hideFullMember = (fullMemberEl) => fullMemberEl.style.display = 'none'

    const selectorMatches = (el, selector) => {
        const p = Element.prototype
        const f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s) {
            return [].indexOf.call(document.querySelectorAll(s), this) !== -1
        }
        return f.call(el, selector)
    }

    const getParent = (selector, el) => {
        let p = el.parentNode;
        while (!selectorMatches(p, selector)) p = p.parentNode;

        return selectorMatches(p, selector)
            ? p
            : undefined
    }

    const clickEl = clickEvent.target
    const memberEl = getParent('.member', clickEl)
    const fullMemberEl = memberEl.querySelector('.full-member')
    const closeEl = fullMemberEl.querySelector('.close')

    const onClickClose = overlayEl => ({currentTarget}) => {
        currentTarget.removeEventListener('click', onClickClose)
        hideFullMember(fullMemberEl)
        hideOverlay(overlayEl)
    }

    showFullMember(fullMemberEl)
    const overlayEl = showOverlay(fullMemberEl)
    closeEl.addEventListener('click', onClickClose(overlayEl))
}



// WEBPACK FOOTER //
// ./advisory-board.js